import React, { useState } from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { isMobile } from 'react-device-detect';

interface Props {
  text: string;
  placement?: TooltipProps['placement'];
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: '-webkit-inline-box',
  },
  button: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey.A200,
    fontFamily: 'monospace',
    minWidth: 16,
    height: 16,
    borderRadius: '50%',
    fontSize: 13,
    fontWeight: 700,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    '&:hover': {
      backgroundColor: theme.palette.grey.A200,
    },
    '& span': {
      marginTop: '-2px',
    },
  },
}));

const TooltipComponent: React.FC<Props> = ({ text, placement }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleClickAway = () => {
    setOpen(false);
  };
  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const mobileTooltip = (
    <div className={classes.root}>
      <Tooltip
        PopperProps={{
          disablePortal: true,
        }}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title={text}
        placement={placement}
      >
        <Button onClick={handleClick} className={[classes.button].join(' ')}>
          i
        </Button>
      </Tooltip>
    </div>
  );

  const desktopTooltip = (
    <>
      <Tooltip title={text} placement={placement}>
        <Button className={[classes.button].join(' ')}>i</Button>
      </Tooltip>
    </>
  );

  return (
    <ClickAwayListener onClickAway={handleClickAway}>{isMobile ? mobileTooltip : desktopTooltip}</ClickAwayListener>
  );
};

TooltipComponent.defaultProps = {
  placement: 'top',
};

export default TooltipComponent;
